import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader, SiteFooter } from "@/components/blog/SiteHeader";
import { Check } from "lucide-react";

const SITE = "https://threedaylaunch.com";
const PATH = "/thank-you-next-steps";
const TITLE = "Book Your Discovery Call — Three Day Launch";
const DESCRIPTION =
  "Thanks for reaching out! Book your discovery call with Sierra Janisse to find the right website strategy for your business.";

export const Route = createFileRoute("/thank-you-next-steps")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: `${SITE}${PATH}` },
      { property: "og:type", content: "website" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: `${SITE}${PATH}` }],
    scripts: [
      {
        type: "text/javascript",
        children: "gtag('event', 'conversion', {'send_to': 'AW-11495268868/RUC-CMHOodQaEITEr-kq'});",
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: TITLE,
          url: `${SITE}${PATH}`,
          description: DESCRIPTION,
          publisher: { "@type": "Organization", name: "Three Day Launch" },
        }),
      },
      {
        type: "text/javascript",
        children: `if (window.location.href.includes("/thank-you-next-steps")) { oaiq("measure", "lead_created", { type: "customer_action" }); }`,
      },
    ],
  }),
  component: ThankYouNextStepsPage,
});

function ThankYouNextStepsPage() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <main className="flex-1">
        <section className="bg-background px-4 py-12 md:py-20">
          <div className="mx-auto max-w-7xl">
            <div className="grid gap-8 lg:grid-cols-2 lg:items-start">
              <div className="lg:sticky lg:top-8">
                <p className="mb-3 text-xs font-bold uppercase tracking-wider text-primary">
                  Thanks for reaching out!
                </p>
                <h1 className="mb-6 font-heading text-3xl font-bold text-foreground md:text-5xl">
                  Now, book your discovery call.
                </h1>
                <p className="mb-6 text-lg text-muted-foreground">
                  Speak directly with Sierra Janisse (Founder and Design Lead) to:
                </p>
                <ul className="space-y-4">
                  {[
                    "Find out which website strategy fits your business best",
                    "Get personalized recommendations",
                    "Start boosting your online visibility the right way",
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-3 text-base text-foreground">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                        <Check className="h-3 w-3" />
                      </span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="overflow-hidden rounded-2xl border border-border bg-card shadow-xl">
                <div className="h-[80vh] min-h-[600px] w-full">
                  <iframe
                    src="https://hello.dubsado.com:443/public/appointment-scheduler/6aa897587fc4536f4e19d14d/schedule?isIframe=true"
                    frameBorder={0}
                    scrolling="yes"
                    className="h-full w-full border-0"
                    title="Schedule a discovery call"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <SiteFooter hideMenu />
    </div>
  );
}
